import axiosInstance from '../axiosInterceptor/axiosInstance'

const getVideoOperators = async (orgId) =>
  (await axiosInstance.get(`v1/orgs/${orgId}/video-operators`))?.data

export default getVideoOperators
